var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('a',{attrs:{"href":_vm.href,"target":"_blank"}},[_c('download-icon',{attrs:{"id":"tooltip-download"}}),_c('b-tooltip',{attrs:{"target":"tooltip-download","triggers":"hover"}},[_vm._v(" 下载游戏 ")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }